import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Hi everyone! I’m <span className="purple">Helen Ren</span>{" "}
            from <span className="purple">Irvine, California</span>.
            <br />
            I’m currently working as a{" "}
            <span className="purple">Software Developer</span> at{" "}
            <span className="purple">XXXX</span>.
            <br />I graduated from Master Degree in{" "}
            <span className="purple">Computing and Infomation Science from</span> from{" "}
            <span className="purple">University of Pittsburgh</span>.
            <br />
            <br />
            Outside of coding, I love engaging in activities that keep me
            creative and inspired:
          </p>

          <ul>
            <li className="about-activity">
              <ImPointRight /> Taking care of my 🐶 & 🐱
            </li>
            <li className="about-activity">
              <ImPointRight /> Reading books📖
            </li>
            <li className="about-activity">
              <ImPointRight /> Traveling and Exploring 🌍
            </li>
          </ul>

          <p style={{ color: "rgb(155 126 172)" }}>
            "Never try, never know"{" "}
          </p>
          <footer className="blockquote-footer">Helen</footer>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
